import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <>
      <main>
        <p>404 Not Found</p>
      </main>
      <nav>
        <Link to="/">Home</Link>
      </nav>
    </>
  );
}

export default NotFound;
